import React, { createContext, useContext, useState } from 'react';

interface User {
  email: string;
  role: 'admin' | 'studio';
  gameId?: string;
  apiKey?: string;
}

interface AuthContextType {
  user: User | null;
  token: string | null;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | null>(null);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<User | null>(() => {
    const saved = localStorage.getItem('gc_user');
    return saved ? JSON.parse(saved) : null;
  });
  const [token, setToken] = useState<string | null>(localStorage.getItem('gc_token'));

  const login = async (email: string, password: string) => {
    if (email === 'admin@gamechain.games' && password === 'admin') {
      const user = { email, role: 'admin' as const };
      setUser(user);
      setToken('admin-token');
      localStorage.setItem('gc_token', 'admin-token');
      localStorage.setItem('gc_user', JSON.stringify(user));
      return;
    }
    if (email === 'studio@example.com' && password === 'studio') {
      const user = { email, role: 'studio' as const, gameId: 'GAME_001', apiKey: 'gc_live_test_key_001' };
      setUser(user);
      setToken('studio-token');
      localStorage.setItem('gc_token', 'studio-token');
      localStorage.setItem('gc_user', JSON.stringify(user));
      return;
    }
    throw new Error('Invalid credentials');
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('gc_token');
    localStorage.removeItem('gc_user');
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}